import React from "react";
import { bool, func, string } from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    marginBottom: "17px",
    borderBottom: `1px solid ${brandTheme.mainColor}`,
    paddingBottom: "1.5%",
  },

  mainContainerWithoutBorder: {
    paddingBottom: "1.5%",
    marginTop: "20px",
  },

  button: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    textTransform: "none",
    
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  
    "@media (max-width: 600px)": {
      width: "calc(100% - 20px)",
      minWidth: "unset",
      margin: "5px 10px",
    },
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: "15px",
    paddingRight: "6%",

    "@media (max-width: 600px)": {
      justifyContent: "center",
      paddingRight: 0,
      flexDirection: "column",
      gap: "10px",
      alignItems: "center",
    },
  },

  buttonContainerCenter: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "15px",

    "@media (max-width: 600px)": {
      flexDirection: "column",
      gap: "10px",
      alignItems: "center",
    },
  },

  button2: {
    backgroundColor: brandTheme.button2Color,

    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },

  button3: {
    backgroundColor: brandTheme.button3Color,

    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },

  auctionButtonContainer: {
    padding: "2% 0 0 9%",
    justifyContent: "flex-start",

    "@media (max-width: 600px)": {
      padding: 0,
      justifyContent: "center",
    },
  },
}));

const BottomButton = ({
  button1,
  button2,
  button3,
  disabled1,
  disabled2,
  disabled3,
  button1click,
  button2click,
  button3click,
  auction,
  type,
  showBorder,
  center,
}) => {
  const classes = useStyles();

  return (
    <Grid
      item
      xs={12}
      className={
        showBorder ? classes.mainContainerWithoutBorder : classes.mainContainer
      }
    >
      <Grid container>
        <Grid
          item
          xs={12}
          className={
            auction
              ? `${classes.auctionButtonContainer} ${classes.buttonContainer}`
              : center
              ? classes.buttonContainerCenter
              : classes.buttonContainer
          }
        >
          {button1 && (
            <Button
              className={classes.button}
              disabled={disabled1}
              onClick={() => (type ? button1click(type) : button1click())}
            >
              {button1}
            </Button>
          )}

          {button2 && (
            <Button
              className={`${classes.button} ${classes.button2}`}
              disabled={disabled2}
              onClick={button2click}
            >
              {button2}
            </Button>
          )}

          {button3 && (
            <Button
              className={`${classes.button} ${classes.button3}`}
              disabled={disabled3}
              onClick={button3click}
            >
              {button3}
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

BottomButton.propTypes = {
  button1: string,
  button2: string,
  button3: string,
  disabled1: bool,
  disabled2: bool,
  disabled3: bool,
  button1click: func,
  button2click: func,
  button3click: func,
  auction: bool,
  showBorder: bool,
};

export default BottomButton;